var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    [
      _vm.isError
        ? _c(
            "v-row",
            [
              _c(
                "v-col",
                {
                  attrs: {
                    cols: "12"
                  }
                },
                [
                  _c(
                    "v-alert",
                    {
                      attrs: {
                        type: "error"
                      }
                    },
                    [_vm._v(" " + _vm._s(_vm.hosting_error) + " ")]
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      !_vm.isError && _vm.inactiveService
        ? _c(
            "v-row",
            [
              _c(
                "v-col",
                {
                  attrs: {
                    cols: "12",
                    sm: "6"
                  }
                },
                [_c("service-info")],
                1
              ),
              _c(
                "v-col",
                {
                  attrs: {
                    cols: "12",
                    sm: "6"
                  }
                },
                [
                  _c("hosting-pending", {
                    attrs: {
                      status: _vm.hosting.status
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      !_vm.isError && !_vm.inactiveService
        ? _c(
            "v-row",
            [
              _c(
                "v-col",
                {
                  attrs: {
                    cols: "12"
                  }
                },
                [
                  _c(
                    "gg-loading",
                    {
                      attrs: {
                        loading: _vm.loading,
                        type: "image",
                        height: "86"
                      }
                    },
                    [
                      _c(
                        "v-tabs",
                        {
                          attrs: {
                            flat: "",
                            "background-color": "transparent"
                          }
                        },
                        [
                          _c("v-tabs-slider", {
                            attrs: {
                              color: "green"
                            }
                          }),
                          _vm._l(_vm.menu, function(item) {
                            return _c(
                              "v-tab",
                              {
                                key: item.route,
                                attrs: {
                                  exact: "",
                                  to: {
                                    name: item.route
                                  }
                                }
                              },
                              [_vm._v(" " + _vm._s(item.title) + " ")]
                            )
                          }),
                          _c(
                            "gg-btn",
                            {
                              staticClass: "align-self-center v-tab",
                              attrs: {
                                color: "primary",
                                text: "",
                                exact: ""
                              },
                              on: {
                                click: function click($event) {
                                  return _vm.launch_whm(_vm.hostingid)
                                }
                              }
                            },
                            [
                              _vm._v(" WHM "),
                              _c(
                                "v-icon",
                                {
                                  staticClass: "ml-1",
                                  attrs: {
                                    small: ""
                                  }
                                },
                                [_vm._v("mdi-open-in-new")]
                              )
                            ],
                            1
                          )
                        ],
                        2
                      )
                    ],
                    1
                  ),
                  _c("hr", {
                    staticClass: "mt-0"
                  })
                ],
                1
              ),
              _c(
                "v-col",
                {
                  staticClass: "pt-0",
                  attrs: {
                    cols: "12"
                  }
                },
                [
                  _c(
                    "gg-loading",
                    {
                      attrs: {
                        loading: _vm.loading,
                        type: "image",
                        height: "400"
                      }
                    },
                    [
                      _c("router-view", {
                        attrs: {
                          loading: _vm.loading
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }